import React, { Component } from 'react'
import { TouchableOpacity, Text } from 'react-native'

class HoverableOpacity extends Component {
    constructor(props) {
        super(props)
        this.state = {
            hover: false,
        };
    }

    render() {
        const { style, hoverstyle, textvalue, onPress, outerstyle } = this.props;

        return (
            <TouchableOpacity
                activeOpacity={1}
                onMouseEnter={() => this.setState({ hover: true })}
                onMouseLeave={() => this.setState({ hover: false })}>
                <TouchableOpacity
                    style={style}
                    onPress={onPress}>
                    <Text style={[this.state.hover ? hoverstyle : {}, outerstyle]}>
                        {textvalue}
                    </Text>
                </TouchableOpacity>
            </TouchableOpacity>
        )
    }
}

export default HoverableOpacity;


// WEBPACK FOOTER //
// ./src/components/HoverableOpacity.js